import { Css, GridTable, useTestIds } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import {
  createPaymentScheduleColumns,
  createPaymentScheduleRows,
} from "src/routes/pdfs/CommitmentOrChangeOrderPdf/components/PaymentScheduleTable";
import { PlanBasedBidLinesSection } from "src/routes/projects/commitments/components/PlanBasedBidLinesSection";
import { usePlanBasedLineItemsTabQuery } from "src/routes/projects/commitments/components/PlanBasedLineItemsTab.generated";
import { ScopeLinesSection } from "src/routes/projects/commitments/components/ScopeLinesSection";
import { IdOrAddParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function PlanBasedLineItemsTab() {
  const tid = useTestIds({});
  const { idOrAdd: commitmentId } = useRouteParams<IdOrAddParams>();
  const query = usePlanBasedLineItemsTabQuery({ variables: { commitmentId } });
  return queryResult(query, ({ commitment: c }) => (
    <>
      <section {...tid.paymentScheduleSection}>
        <h2 css={Css.mdSb.mt3.mb1.$}>Payment Schedule</h2>
        <GridTable
          columns={createPaymentScheduleColumns(c.project.id, c.committedInCents, true)}
          rows={createPaymentScheduleRows(c.draws, c.depositInBasisPoints)}
        />
      </section>
      <PlanBasedBidLinesSection lineItems={c.lineItems} />
      <ScopeLinesSection lineItems={c.lineItems} />
    </>
  ));
}
